import { Employee } from './wizard.model';

export class JobScheduleViewModel {
  jobScheduleId: any;
  companyId!: number;
  companyName!: string;
  contractId!: string;
  jobId!: string;
  jobDescription!: string;
  googleUrl!: string;
  startDate!: Date;
  jobScheduleStatusId: any;
  jobScheduleStatusName: any;
  jobSchedulePhaseViewModelList!: JobSchedulePhaseViewModel[];
  inspectorNeeded!: boolean;
  inspectorCalled!: boolean;
  rainedOut!: boolean;
  createdBy!: string;
  notes!: string;
  previousJobScheduleStatusName!: string;
  previousJobScheduleStatusId: any;
  reviewHTML!: string;
}

export class JobSchedulePhaseViewModel {
  jobScheduleId: any;
  phaseId!: string;
  jobId: any;
  phaseDescription!: string;
  estLaborProd!: string;
  createdDate: any;
  createdBy!: string;
  modifiedDate: any;
  modifiedBy: any;
  isDeleted!: boolean;
  isModified!: boolean;
  employees: any;
  employeesFullName: any;
  expProd: any;
  employee: any;
  phaseIdDescription!: string;
  itemIdDescription!: string;
  bidHrs!: string;
  jtdHrs!: string;
  remHrs!: string;
  jobSchedulePhaseWorkForceViewModelList!: JobSchedulePhaseWorkForceViewModel[];
  employeeViewModelList!: Employee[];
  currentCompanyEmployeeViewModelList!: Employee[];
}

export class JobSchedulePhaseWorkForceViewModel {
  jobSchedulePhaseWorkForceId?: any;
  jobScheduleId?: any;
  jobSchedulePhaseId?: any;
  employeeId: any;
  isDeleted: any;
  worksFor: any;
}

export class GeneralNotesViewModel {
  generalNotesId: any;
  text: any;
  notesDate: any;
}
